import { render } from "./TeamDashboard.vue?vue&type=template&id=715b6ddc&scoped=true"
import script from "./TeamDashboard.vue?vue&type=script&lang=js"
export * from "./TeamDashboard.vue?vue&type=script&lang=js"

import "./TeamDashboard.vue?vue&type=style&index=0&id=715b6ddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715b6ddc"]])

export default __exports__